import Chapter from './chapter.js';
import Info from './info.js';

import { assortment } from '../data/data.js';

function Main() {
    return ( 
        <main className='main'>
            <div className='main__menu tile order__1 animloadWithSlide'>
                <Chapter
                    chapterIndex={0}
                    chapter={assortment[0]}
                />
            </div>

            <div className='main__menu tile main__menu__special order__2 animloadWithSlide'>
                <Chapter
                    chapterIndex={1}
                    chapter={assortment[1]}
                />
                <div className='main__breaker' />
                <Chapter
                    chapterIndex={2}
                    chapter={assortment[2]}
                />
            </div>

            <Info />
        </main> 
    );
}

export default Main;